const SET_AD = (state, data) => {
  state.ad = data
}

export default {
  SET_AD
}
